import React from 'react';
import classes from './DeleteChatModal.module.scss';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Button/Button';

export const DeleteChatModal = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <header>
          <h1>
            <FormattedMessage id="components.deleteChatModal.deleteChatHistory" defaultMessage="Delete Chat History?" />
          </h1>
          <h6>
            <FormattedMessage id="components.deleteChatModal.warning" defaultMessage="WARNING!" />
          </h6>
          <h6 className={classes.buttonMargin}>
            <FormattedMessage
              id="components.deleteChatModal.deleteText"
              defaultMessage="You are about to delete the chat conversation history for all the participants."
            />
          </h6>
          <h6>
            <FormattedMessage id="components.deleteChatModal.action" defaultMessage="This action is non-recoverable." />
          </h6>
        </header>
        <div className={classes.buttonBar}>
          <Button
            kind="secondary"
            onClick={() => {
              props.closeDeleteModal();
            }}
          >
            <FormattedMessage id="components.startCallModal.cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            onClick={() => {
              props.onDeleteChat(props.chatDetails);
              props.closeDeleteModal();
            }}
          >
            <FormattedMessage id="delete" defaultMessage="Delete" />
          </Button>
        </div>
      </div>
    </div>
  );
};
